import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "empty"];
import React from "react";
export var Intro = function Intro(_ref) {
  var children = _ref.children,
      empty = _ref.empty,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("section", _extends({
    className: "intro"
  }, otherProps), empty && /*#__PURE__*/React.createElement("p", null, "Click here to add introductory text"), /*#__PURE__*/React.createElement("p", null, children));
};